// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/viabovag." + {"2474":"chat-client-web1on1","3482":"chat-client-bconnect","7853":"recaptcha"}[chunkId] + "." + {"2474":"d8ea7164","3482":"7f03ac59","7853":"be156656"}[chunkId] + ".min.js";
};